var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.592 2.78-.084-.531H.991l-.084.531h.483c2.382 0 5.42-.18 7.718 0h.484Zm-4.76 2.435c0-.237.187-.43.417-.43.23 0 .418.193.418.43v6.351c0 .237-.187.43-.418.43a.424.424 0 0 1-.417-.43V5.215Zm1.985-.022a.421.421 0 0 1 .437-.406c.23.012.407.213.395.45l-.335 6.35a.421.421 0 0 1-.437.407.424.424 0 0 1-.395-.45l.335-6.351Zm-3.967.043a.424.424 0 0 1 .395-.449c.23-.012.425.17.437.406l.335 6.351a.424.424 0 0 1-.395.45.421.421 0 0 1-.437-.406L2.85 5.236ZM4.11.86l-.077.531h2.433L6.389.86H4.11Zm-.92.531L3.336.388A.422.422 0 0 1 3.75 0h2.997c.204 0 .382.154.413.367l.148 1.023h2.553c.2.001.377.15.41.36l.216 1.358a.424.424 0 0 1-.406.53h-.579l-.45 8.523c-.026.508-.232.97-.556 1.303-.321.331-.758.536-1.252.536H3.254c-.494 0-.93-.205-1.253-.536a2.021 2.021 0 0 1-.556-1.303L.995 3.64H.416L.35 3.632a.427.427 0 0 1-.344-.491l.216-1.359a.422.422 0 0 1 .416-.392H3.19ZM1.83 3.64l.447 8.479c.016.288.132.551.315.74.17.175.401.283.662.283h3.991c.26 0 .491-.108.662-.284.183-.188.3-.45.315-.74l.447-8.478H1.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.e01dfc301cf5daaed5a80bae1a0332ba.svg";
export { ForwardRef as ReactComponent };